import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'


type SubsidyTypes = Array<ItemType>

class SubsidyTypeFilterDataBox extends DataBox<SubsidyTypes> { }

export const defaultSubsidyType: SubsidyTypes = []
export const subsidyTypeFilter = createDataBox('subsidyTypeFilter', defaultSubsidyType, SubsidyTypeFilterDataBox)

export const defaultSubsidyTypeData = () => {
  return [{
    id: 'common',
    title: 'Общая',
  }, {
    id: 'personal',
    title: 'Индивидуальная',
  }]
}

subsidyTypeFilter.updateData(defaultSubsidyTypeData)
subsidyTypeFilter.setStatusReady()

export const defaultSubsidyTypeSelection: Array<string> = []
export const subsidyTypeFilterSelection = createDataBoxDefault<Array<string>>('subsidyTypeFilterSelection', defaultSubsidyTypeSelection)
